import React from "react";

export const SlidesLayout = ({
  children,
  id,
}: {
  children: React.ReactNode;
  id?: string;
}) => {
  return (
    <>
      <div
        id={id}
        className="gg-h-full gg-overflow-y-auto gg-rounded-lg gg-bg-white gg-shadow-sm"
      >
        <div className="gg-min-h-[500px] gg-px-2 gg-pb-5 gg-pt-4">
          {children}
        </div>
      </div>
    </>
  );
};
